import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirectService } from 'src/app/service/redirect.service';
import { sspConfig, sspConfigUrls } from 'src/environments/environment';
import { LoginService } from '../../service/login.service';

@Component({
    selector: 'app-ssp',
    template: ''
})
export class SspComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private redirectService: RedirectService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    const currentParams = this.route.snapshot.queryParams;

    if (window.location.href.includes('ssp/amlForm')) {
      const newParams = { formName: 'amlForm' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('ssp/loanConfirmationForm')) {
      const newParams = { formName: 'loanConfirmationForm' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('ssp/deferralForm')) {
      const newParams = { formName: 'deferralForm' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('ssp/changeDebitDateForm')) {
      const newParams = { formName: 'changeDebitDateForm' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('ssp/changeDebitAccountForm')) {
      const newParams = { formName: 'changeDebitAccountForm' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('ssp/ca-confirmation')) {
      const newParams = { formName: 'ca-confirmation' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('ssp/debit-reduction')) {
      const newParams = { formName: 'debit-reduction' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('ssp/product-confirmation')) {
      const newParams = { formName: 'product-confirmation' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('ssp/chatbot-ticket')) {
      const newParams = { formName: 'chatbot-ticket' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('ssp/secured-id-update')) {
      const newParams = { formName: 'secured-id-update' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('ssp/secured-rp-update')) {
      const newParams = { formName: 'secured-rp-update' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    }
     else if (window.location.href.includes('ssp/cashless-payment')) {
      const newParams = { formName: 'cashless-payment' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    }
     else if (window.location.href.includes('ssp/cashless-salary-payment')) {
      const newParams = { formName: 'cashless-salary-payment' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    }
     else if (window.location.href.includes('ssp/cashless-pension-payment')) {
      const newParams = { formName: 'cashless-pension-payment' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('ssp/personal-data-change')) {
      const newParams = { formName: 'personal-data-change' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('ssp/ticket-status-check')) {
      const newParams = { formName: 'ticket-status-check' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    }

    const buildUrl = (
      baseUrl: string,
      queryParams: { [key: string]: string | undefined }
    ) => {
     // const queryString = Object.entries(queryParams)
      const resolvedQueryParams = { ...queryParams };
      const id = this.route.snapshot.queryParams['id'];

      if (
        id !== undefined &&
        id !== '' &&
        (resolvedQueryParams['id'] === undefined || resolvedQueryParams['id'] === '')
      ) {
        resolvedQueryParams['id'] = id;
      }

      const queryString = Object.entries(resolvedQueryParams)
        .filter(([_, value]) => value !== undefined && value !== '')
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
      if (!queryString) {
        return baseUrl;
      }

      const separator = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${separator}${queryString}`;
    };

    this.route.queryParams.subscribe(async (params) => {
      const formName = params['formName'];
      const inApp = params['inApp'];
      const lang = params['lang'];
      const tenant = params['tenanthost'];
      const productIdentifier = params['product_identifier'];
      const changeType = params['changeType'];
      const ticketNumber = params['ticketNumber'];

      switch (formName) {
        case 'amlForm':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(sspConfigUrls.amlFormUrl, {
              ebanking: 'true',
              lang,
              product_identifier: productIdentifier,
            });
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(sspConfigUrls.amlFormUrl, {
              inApp: 'true',
              lang,
              product_identifier: productIdentifier,
            });
          } else {
            sspConfig.redirectUri = sspConfigUrls.amlFormUrl;
          }
          break;
        case 'loanConfirmationForm':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.loanConfirmationFormUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.loanConfirmationFormUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspConfig.redirectUri = sspConfigUrls.loanConfirmationFormUrl;
          }
          break;
        case 'deferralForm':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.loanDeferralFormUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.loanDeferralFormUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspConfig.redirectUri = sspConfigUrls.loanDeferralFormUrl;
          }
          break;
        case 'changeDebitDateForm':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.changeDebitDateForm,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.changeDebitDateForm,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspConfig.redirectUri = sspConfigUrls.changeDebitDateForm;
          }
          break;
        case 'changeDebitAccountForm':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.changeDebitAccountForm,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.changeDebitAccountForm,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspConfig.redirectUri = sspConfigUrls.changeDebitAccountForm;
          }
          break;
        case 'ca-confirmation':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.currentAccountFormUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.currentAccountFormUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspConfig.redirectUri = sspConfigUrls.currentAccountFormUrl;
          }
          break;
        case 'debit-reduction':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.debitReductionFormUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.debitReductionFormUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspConfig.redirectUri = sspConfigUrls.debitReductionFormUrl;
          }
          break;
        case 'product-confirmation':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.productConfirmationUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.productConfirmationUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspConfig.redirectUri = sspConfigUrls.productConfirmationUrl;
          }
          break;
        case 'chatbot-ticket':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.chatbotTicketUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.chatbotTicketUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspConfig.redirectUri = sspConfigUrls.chatbotTicketUrl;
          }
        break;
        case 'ticket-status-check':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.disTicketStatusUrl,
              { ebanking: 'true', lang, ticketNumber },
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.disTicketStatusUrl,
              { inApp: 'true', lang, ticketNumber },
            );
          } else {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.disTicketStatusUrl,
              { ticketNumber },
            );
          }
          break;
         case 'cashless-payment':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.cashlessPaymentUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.cashlessPaymentUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspConfig.redirectUri = sspConfigUrls.cashlessPaymentUrl;
          }
        break;
         case 'cashless-salary-payment':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.cashlessSalaryPaymentUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.cashlessSalaryPaymentUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspConfig.redirectUri = sspConfigUrls.cashlessSalaryPaymentUrl;
          }
        break;
         case 'cashless-pension-payment':
          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.cashlessPensionPaymentUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls.cashlessPensionPaymentUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspConfig.redirectUri = sspConfigUrls.cashlessPensionPaymentUrl;
          }
        break;
        default:
          // applicable only for new generic forms (DEM1521-7506, DEM1521-7843, DEM1527-6999)
          const formUrl = formName.includes('-')
            ? formName.replace(/-./g, (match: string) =>
                match.charAt(1).toUpperCase()
              ) + 'Url'
            : formName + 'Url';

          if (tenant === 'eb') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls[formUrl as keyof typeof sspConfigUrls],
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
                changeType,
              }
            );
          } else if (inApp === 'true') {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls[formUrl as keyof typeof sspConfigUrls],
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
                changeType,
              }
            );
          } else {
            sspConfig.redirectUri = buildUrl(
              sspConfigUrls[formUrl as keyof typeof sspConfigUrls],
              {
                changeType,
              }
            );
          }
          break;
      }
    });
  }

  ngOnInit(): void {
    //  this.redirectService.redirect(sspConfig.redirectUri)
    this.loginService.login(sspConfig);
  }
}